export default "__VITE_ASSET__BdRLcfwQ__"